//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
	name: 'loadmore',
	props: ['pagination', 'content_type', 'load_type', 'load_on_scroll', 'included', 'slug'],
	computed: {
		...mapState({
			queries: ({ resourcesStore: {queries} }) => queries,
			loading: ({ resourcesStore: {loading} }) => loading
		}),
	},
	methods: {
		loadMore() {
			if (this.pagination.current_page < this.pagination.total_pages) {
				// Deep clone this.query to ensure no references to the Vuex state
				let loadmoreQuery = JSON.parse(JSON.stringify(this.queries[this.load_type]));
				if(this.load_type === 'search' && this.$route.query.search) {
					if(!loadmoreQuery.search.all) {
						loadmoreQuery.search.all = this.$route.query.search;
					}
				}
				if (this.included) {
					loadmoreQuery.include[0].resources.pagination.page = this.pagination.current_page + 1 ;
					loadmoreQuery.slug = this.slug;
					this.$store.commit('resourcesStore/updateQuery', loadmoreQuery);
					this.$store.dispatch('resourcesStore/getIncludedResources', loadmoreQuery);
				} else {
					loadmoreQuery.pagination.page = this.pagination.current_page + 1 ;
					this.$store.commit('resourcesStore/updateQuery', loadmoreQuery);
					this.$store.dispatch('resourcesStore/getResources', loadmoreQuery);
				}
			} else {
				return
			}
		}
	}
}
